import { SxProps } from '@mui/material'

import { navigationDrawerClasses, navigationDrawerDimensions } from './NavigationDrawer.data'
import { headerDimensions } from '../../Header.data'

interface NavigationDrawerStyles {
  container: SxProps
  headerContainer: SxProps
}

export const navigationDrawerStyles: NavigationDrawerStyles = {
  container: {
    width: '100%',
    maxWidth: '100%',
    position: 'relative',
  },
  headerContainer: {
    width: '100%',
    padding: 2.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: navigationDrawerDimensions.header,
    [`.${navigationDrawerClasses.logo}`]: {
      width: headerDimensions.logo.stackedIconMobile,
    },

    [`.${navigationDrawerClasses.logoFanatics}`]: {
      color: 'common.black',
      width: headerDimensions.logo.mobile + 10,
    },

    [`.${navigationDrawerClasses.crossIcon}`]: {
      width: 24,
      cursor: 'pointer',
    },
  },
}
